import { render, staticRenderFns } from "./InviteTenders.vue?vue&type=template&id=4a8e4991&scoped=true&"
import script from "./InviteTenders.vue?vue&type=script&lang=js&"
export * from "./InviteTenders.vue?vue&type=script&lang=js&"
import style0 from "./InviteTenders.vue?vue&type=style&index=0&id=4a8e4991&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8e4991",
  null
  
)

export default component.exports